import React from "react";
import { Label } from "reactstrap";
import Required from "./Required";

const OrderComponent = ({ title, name, register, watch, trigger, errors, handleChange, setValue, placeholder,required }) => {
  return (
    <div className="form-group">
      <Label className="from-label" htmlFor={name}>
        {title}
       {required&& <Required />}
      </Label>
      <div className="form-control-wrap">
        <input
          placeholder={placeholder}
          type="Number"
          id={name}
          {...register(name, {
            required: {
              value: required,
              message: `${name} is required`,
            },
            // pattern: {
            //   value: /^(?!\s*$)[a-zA-Z /.]*$/,
            //   message: "Only alphabets are allowed",
            // },
            minLength: {
              value: 1,
              message: `${name} must be at least 2 characters long`,
            },
            maxLength: {
              value: 100,
              message: `${name} cannot exceed 50 characters`,
            },
          })}
          className="form-control"
          value={watch(name)}
          onChange={(e) => {
            setValue(name, e.target.value);
            trigger(name); // Trigger validation
          }}
        />
        {errors[name] && (
          <span
            className="invalid"
            style={{
              color: "#e85347",
              fontSize: "11px",
              fontStyle: "italic",
            }}
          >
            {errors[name]?.message}
          </span>
        )}
      </div>
    </div>
  );
};

export default OrderComponent;
